module.exports = __webpack_public_path__ + "static/media/argumentsInEvidence.42e75663.jpg";